
export const getInvestmentProfileType = (context, createdBy, parameters, result) => {
  const { profileType } = result
  return (profileType?.toLowerCase() || `${profileType}`)
    .replace('individual', 'personal')
}
